(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["duff-home-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[id^="DuffExact-"]');
  if (!root || root.dataset.sliderReady === 'true') return;
  root.dataset.sliderReady = 'true';
  const slider = root.querySelector('.dsx-slider');
  const slides = Array.from(root.querySelectorAll('[data-slide]'));
  const dots = Array.from(root.querySelectorAll('.dsx-dot'));
  if (!slider || slides.length < 2) return;
  let index = 0;
  let timer;
  let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let hovering = false;
  let focusing = false;
  const pauseButton = root.querySelector('.dsx-hero-pause');
  const show = (next) => {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      const active = i === index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
      slide.inert = !active;
    });
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
      dot.setAttribute('aria-pressed', String(i === index));
    });
  };
  const stop = () => { if (timer) window.clearInterval(timer); timer = undefined; };
  const start = () => {
    stop();
    if (slider.dataset.autoplay === 'true' && !paused && !hovering && !focusing) {
      timer = window.setInterval(() => show(index + 1), Number(slider.dataset.speed) || 7000);
    }
  };
  root.querySelector('.dsx-prev')?.addEventListener('click', () => { show(index - 1); start(); });
  root.querySelector('.dsx-next')?.addEventListener('click', () => { show(index + 1); start(); });
  dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
  const updatePauseButton = () => {
    if (!pauseButton) return;
    const label = paused ? pauseButton.dataset.playLabel : pauseButton.dataset.pauseLabel;
    pauseButton.setAttribute('aria-label', label);
    pauseButton.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
    root.querySelector('.dsx-slides')?.setAttribute('aria-live', paused ? 'polite' : 'off');
  };
  pauseButton?.addEventListener('click', () => { paused = !paused; updatePauseButton(); start(); });
  slider.addEventListener('mouseenter', () => { hovering = true; stop(); });
  slider.addEventListener('mouseleave', () => { hovering = false; start(); });
  slider.addEventListener('focusin', () => { focusing = true; stop(); });
  slider.addEventListener('focusout', (event) => {
    if (!slider.contains(event.relatedTarget)) { focusing = false; start(); }
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else start(); });
  root.addEventListener('shopify:block:select', (event) => {
    const selected = event.target.closest('[data-slide]');
    const selectedIndex = slides.indexOf(selected);
    if (selectedIndex !== -1) { paused = true; show(selectedIndex); updatePauseButton(); stop(); }
  });
  updatePauseButton();
  start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
